import { render, staticRenderFns } from "./SearchFree.vue?vue&type=template&id=bfce2d6e"
import script from "./SearchFree.vue?vue&type=script&lang=js"
export * from "./SearchFree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports